<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="person.first_name"
      :label="$gettext('Nome')"
      :error-messages="error.first_name || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.last_name"
      :error-messages="error.last_name || ''"
      :label="$gettext('Cognome')"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.stage_name"
      :error-messages="error.stage_name || ''"
      :label="$gettext('Nome d\'arte')"
    ></v-text-field>
    <autocomplete
      v-if="profile.is_staff"
      v-model="person.roles"
      :error-messages="error.roles || ''"
      :model="personRoleModel"
      item-text="name"
      item-value="id"
      chips
      label="Ruoli"
      multiple
    ></autocomplete>
    <autocomplete
      v-if="profile.is_staff"
      v-model="person.instruments"
      :error-messages="error.instruments || ''"
      :model="instrumentModel"
      item-text="name"
      item-value="id"
      chips
      label="Strumenti"
      multiple
    ></autocomplete>
    <autocomplete
      v-if="profile.is_staff"
      v-model="person.category"
      :error-messages="error.category || ''"
      :model="personCategoryModel"
      item-text="name"
      item-value="id"
      label="Categoria"
    ></autocomplete>
    <v-text-field
      v-model="person.citizenship_code"
      :error-messages="error.citizenship_code || ''"
      :label="$gettext('Cittadinanza')"
    ></v-text-field>
    <v-radio-group v-model="person.gender" row>
      <template v-slot:label>
        <div v-translate>Sesso *</div>
      </template>
      <v-radio :label="$gettext('Maschile')" :value="1"></v-radio>
      <v-radio :label="$gettext('Femminile')" :value="2"></v-radio>
    </v-radio-group>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      allow-overflow
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="person.date_of_birth"
          :label="$gettext('Data di nascita *')"
          :error-messages="error.date_of_birth || ''"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="person.date_of_birth"
        :max="new Date().toISOString().substr(0, 10)"
        min="1900-01-01"
      ></v-date-picker>
    </v-menu>
    <v-text-field
      v-model="person.city_of_birth"
      :label="$gettext('Città di nascita *')"
      :error-messages="error.city_of_birth || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.district_of_birth"
      :label="$gettext('Provincia di nascita **')"
      :error-messages="error.district_of_birth || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.country_of_birth"
      :label="$gettext('Nazione di nascita *')"
      :error-messages="error.country_of_birth || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.city_of_residence"
      :label="$gettext('Città di residenza *')"
      :error-messages="error.city_of_residence || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.district_of_residence"
      :label="$gettext('Provincia di residenza **')"
      :error-messages="error.district_of_residence || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.country_of_residence"
      :label="$gettext('Nazione di residenza *')"
      :error-messages="error.country_of_residence || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.address"
      :label="$gettext('Indirizzo *')"
      :error-messages="error.address || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.postal_code"
      :label="$gettext('Codice postale')"
      :error-messages="error.postal_code || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.telephone_number"
      :label="$gettext('Contatti telefonici *')"
      :error-messages="error.telephone_number || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.email"
      :label="$gettext('Email')"
      :error-messages="error.email || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="person.fiscal_code"
      :label="$gettext('Codice fiscale italiano **')"
      :error-messages="error.fiscal_code || ''"
      :hint="
        $gettext(
          'Se NON in possesso del codice fiscale italiano, inviare copia del passaporto all\'indirizzo antonietta.micheli@oficinaocm.com'
        )
      "
      persistent-hint
      required
    ></v-text-field>
    <v-text-field
      v-model="person.foreign_fiscal_code"
      :label="$gettext('Codice fiscale estero')"
      :error-messages="error.foreign_fiscal_code || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.vat_number"
      :label="$gettext('Partita IVA')"
      :error-messages="error.vat_number || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.vat_regime"
      :label="$gettext('Regime IVA')"
      :error-messages="error.vat_regime || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.foreign_vat_number"
      :label="$gettext('Partita IVA estera')"
      :error-messages="error.foreign_vat_number || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.enpals_serial_number"
      :label="$gettext('Matricola ENPALS')"
      :error-messages="error.enpals_serial_number || ''"
    ></v-text-field>
    <v-select
      v-model="person.international_tax_exemption"
      :label="$gettext('Esenzione internazionale contributi')"
      :error-messages="error.international_tax_exemption || ''"
      :items="[
        { value: 0, text: ' ' },
        { value: 1, text: $gettext('Nessuna esenzione') },
        { value: 2, text: $gettext('Mod. A1') },
        { value: 3, text: $gettext('IT4 USA') },
      ]"
    ></v-select>

    <p v-translate>
      I campi seguenti sono solo per gli extracomunitari con permesso di
      soggiorno.
    </p>
    <v-text-field
      v-model="person.permission_type"
      :label="$gettext('Tipo di permesso')"
      :error-messages="error.permission_type || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.permission_reason"
      :label="$gettext('Motivo del permesso')"
      :error-messages="error.permission_reason || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.permission_number"
      :label="$gettext('Numero di permesso')"
      :error-messages="error.permission_number || ''"
    ></v-text-field>
    <!-- missing: scadenza -->
    <v-text-field
      v-model="person.police_hq_release"
      :label="$gettext('Questura di rilascio **')"
      :error-messages="error.police_hq_release || ''"
    ></v-text-field>

    <v-textarea
      v-model="person.notes"
      :error-messages="error.notes || ''"
      :label="$gettext('Note')"
    ></v-textarea>
    <v-text-field
      v-model="person.bank"
      :label="$gettext('Banca')"
      :error-messages="error.bank || ''"
    ></v-text-field>
    <v-text-field
      v-model="person.iban"
      :label="$gettext('IBAN')"
      :error-messages="error.iban || ''"
      :hint="
        $gettext('Il conto d\'appoggio deve essere intestato a') +
        `${person.first_name} ${person.last_name}.`
      "
      persistent-hint
    ></v-text-field>
    <v-text-field
      v-model="person.bic_swift"
      :label="$gettext('BIC/SWIFT')"
      :error-messages="error.bic_swift || ''"
    ></v-text-field>

    <v-checkbox
      v-model="person.is_verified"
      :label="$gettext('Verificato')"
      :hint="
        $gettext('Questa spunta si compila automaticamente al salvataggio.')
      "
      persistent-hint
      disabled
    ></v-checkbox>

    <br />
    <a v-if="!person.has_user && get(withData, 'email')" @click="createUser()">
      Crea utente
      <b>{{ withData.email }}</b>
      per questa persona
    </a>

    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

import models from "@/models"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      person: {},
      instrumentModel: models.Instrument,
      personCategoryModel: models.PersonCategory,
      personRoleModel: models.PersonRole,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    createUser() {
      this.$store
        .dispatch("createUser", this.person.id)
        .then((response) => {
          this.$store.commit("core/setSnack", {
            level: "success",
            msg: response.detail,
          })
          this.person.has_user = true
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          this.$store.commit("core/setSnack", {
            level: "error",
            msg: "Errore.",
          })
          // console.log(err)
        })
    },
    reset() {
      this.person = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.person)
    },
  },
}
</script>
